import { render, staticRenderFns } from "./message.vue?vue&type=template&id=5bd300bc&scoped=true&"
import script from "./message.vue?vue&type=script&lang=js&"
export * from "./message.vue?vue&type=script&lang=js&"
import style0 from "./message.vue?vue&type=style&index=0&id=5bd300bc&prod&lang=css&"
import style1 from "./message.vue?vue&type=style&index=1&id=5bd300bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd300bc",
  null
  
)

export default component.exports